export var config = {
    prop: 1
};
//# sourceMappingURL=config.js.map